<template>
  <div class="loan">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>
  	<div class="row">
      <div class="flex xs12 md5">
      	 <va-card :title="$t('loan-EditLoan')">
      	 	<template slot="actions">           
	            <va-button icon="fa fa-close" @click="$router.go(-1)">Cancel</va-button>	           
	        </template>
          <form @submit.prevent="onsubmit">

           <va-select
			              class="mb-4"
			              label="Product"
			              v-model="code"
                    searchable
			              textBy="description"
			              :loading = "loadSelect"
			              :options="loans"
			              key-by="code"
                    @input="setSelected"
			            />
          <va-input
              :label="$t('Basic Salary')"
              type="number"
              v-model="this.formdata.basicPay"
              :error="!!basicPay.length"
              :error-messages="basicsalaryErrors"
             
            />

            <va-input 
              :label="$t('Loan Amount')"
               type="number"         
               v-model="formdata.appliedamount"
               :error="!!amountErrors.length"
               
            />
            <va-select
			              class="mb-4"
			              label="Purpose"
			              v-model="id"
                    searchable
			              textBy="name"
			              :loading = "loadpurpose"
                    :error="!!loanpurpose.length"
                    :error-messages="loanpurposeErrors.length"
			              :options="purpose"
			              key-by="id"
			            />

                  <va-select
                  class="mb-4"
                  label="Disbursement Mode"
                  v-model="formdata.disbursement"
                  searchable
                  textBy="name"
                  :loading = "isLoading"
                  :error="!!disbursement.length"
                  :error-messages="disbursement.length"
                  :options="disbursement"
                  key-by="name"
                />
       <va-input 
              :label="$t('Total Allowances')"
               type="number"
              v-model="this.formdata.allowance"           
              :error="!!allowance.length"
              :error-messages="!!allowanceErrors.length"
               @input="grossSalaryQ"
                
            />	
             <va-input               
              :label="$t('Gross Salary')"
               type="number"
              v-model="this.formdata.grossSalary"           
              :error="!!grossSalary.length"
              :error-messages="grossSalaryErrors.length"
              :readonly = "true"  
          
            />	

            <va-input
            :label="$t('period-months')"
            type="number"
            v-model="newPeriod"
            @blur="validateInstallments"
            :error="!!grossSalary.length"
            :error-messages="grossSalaryErrors.length"
          />
            <va-input
              :label="$t('interest %')"
              type="number"
              v-model="this.newInterest"
              :readonly = "true"                     
            />
            <va-input
              :label="$t('Total Interest')"
              type="number"
              v-model="this.totalInterest"
              :readonly = "true"   
              v-if="showIterest"                  
            />
           <div class="row mt-5"> 
            <va-button
              
              type="button" @click="getschedule">Preview Loan Schedule</va-button>
                </div> 
        	 	<div class="row mt-5">            
                <va-button type="submit" >
                  {{ $t('forms.controls.submit') }}
                </va-button>                        
            </div>
          </form>
      	 </va-card>
      </div>

      <div class="flex xs12 md12 xl7" v-if="showInfo">
        <template>
          <va-card :title="$t('Loan Schedule')">
                <div class="row align--center mb-1">
                  <div class="flex xs12 sm6">
                    <va-input
                      class="ma-0"
                      :value="term"
                      :placeholder="$t('tables.searchByName')"
                      @input="search"
                      removable
                    >
                      <va-icon name="fa fa-search" slot="prepend" />
                    </va-input>
                  </div>
                </div>

                <va-data-table
                  :fields="mode ? detailedFields : fields"
                  :data="filteredData"
                  :loading="loading"
                  hoverable
                  no-pagination
                >
                  <template v-slot:installment_no="props">
                    {{ props.rowData.installment_no }}
                  </template>
                  <template v-slot:date="props">
                    {{ props.rowData.date | formatDate }}, 20{{props.rowData.repayment_year }}
                  </template>
                  <template v-slot:payment_amount="props">
                    <div style="text-align: right;">{{ props.rowData.payment_amount | Currency }}</div>
                  </template>
                  <template v-slot:interest="props">
                    <div style="text-align: right;">{{ props.rowData.interest | Currency }}</div>
                  </template>
                  <template v-slot:principle="props">
                    <div style="text-align: right;">{{ props.rowData.principle | Currency }}</div>
                  </template>
                  <template v-slot:loan_balance="props">
                    <div style="text-align: right;">{{ props.rowData.loan_balance | Currency }}</div>
                  </template>
                </va-data-table>
              </va-card>        
        </template>
      </div>
    </div>

  </div>
</template>
<script src="https://unpkg.com/vue@2.5.13/dist/vue.js"></script>
<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners      
  },
  name: 'loan',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),   
      loan_no : this.$route.params.loan_no,
      loading: false,
      loadSelect:false,
      loadpurpose:false,
      loaddisbursement:false,
      processingError: false,
      payment_method : '',
      newInterest:'',
      code: '',
      date:'',
      finalPost : '',
      formdata:{
      	payment_mode:'',
        phone_no:'',
        basicPay:'',
        RepaymentPeriod:'',
     
        appliedamount:'',
        loanpurpose:'',
        disbursement:'',
        repaymentperiod:'',
        grossSalary:'',
        productID:'',

        user: '',
         allowance:'',
          montlyrepayment:'',
      },
      basicsalaryErrors : [],
      allowanceErrors : [],
      grossSalaryErrors: [],
      loanpurposeErrors: [],
      disbursementErrors:[],
      repaymentperiodErrors: [],
      loanAmountErrors: [],
      montlyrepaymentErrors: [],
      showMpesa : false,
      showFosa: false,
      showInfo:false,
      showIterest:false,
      schedule:{},
      showConfirmModal : false, 
      accname: '',
      RepaymentPeriod:'',
      newPeriod:'',
      maxPeriod:'',
      date:'',
      loanType:'',
      purposecode: '',
      charge:'',
      basicPay:'',
      appliedamount:'',
      repaymentperiod:'',
      loanpurpose:'',
      disbursement:'',
      allowance:'',
      productID:'',
      grossSalary:'',
      
      totalloanrepayment:'',
      Totalinterest:'',
      totalInterest:'',
      amountErrors : [],
      montlyrepayment:'',
      loans: [
        {
          code: '',
          description: 'select an Option',
        }],
        disbursement: [
      {  name: 'Bank Transfer' },
      {  name: 'Mpesa' }
    ],
        purpose: [],
      id: '',
      product_id:'',
      outc:'',
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },
//      grossSalary(){
//         //console.log(input);
//         //console.log(parseInt(this.formdata.basicsalary) - parseInt(this.formdata.allawances));
// return  parseInt(this.formdata.basicsalary) - parseInt(this.formdata.allawances);
//     },
fields () {
      return [{
        name: '__slot:installment_no',
        title: this.$t('tables.headings.installment_no'),
        sortField: 'installment_no',
      },
      {
        name: '__slot:date',
        title: this.$t('tables.headings.date'),       
        sortField: 'date',
      }, 
 
      {
        name: '__slot:payment_amount',
        title: this.$t('tables.headings.payment_amount'),       
        sortField: 'payment_amount',
      }, 
      {
        name: '__slot:interest',
        title: this.$t('tables.headings.interest'),       
        sortField: 'interest',
      },
      {
        name: '__slot:principle',
        title: this.$t('tables.headings.principle'),       
        sortField: 'principle',
      },
      {
        name: '__slot:loan_balance',
        title: this.$t('tables.headings.loan_balance'),       
        sortField: 'loan_balance',
      }]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.schedule
      }
      return this.schedule.filter(item => {
        return item.date.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
    formReady () {
      return !this.basicsalaryErrors.length && !this.allowanceErrors.length && !this.montlyrepaymentErrors.length
      && !this.loanAmountErrors.length && !this.amountErrors.length && !this.repaymentperiodErrors.length && !this.loanAmountErrors.length && !this.grossSalaryErrors.length
    }, 
         
  },
  methods : {
    GetProduct(id) {      
      return this.loans.filter(item => item.code.toLowerCase() === this.id.toLowerCase());      
    },
    GetPurpose(id) {      
      return this.codes.filter(item => item.purposecode.toLowerCase() === this.id.toLowerCase());      
    },
    
 
    onsubmit (e) {
      e.preventDefault();
      this.processingError = false;
      this.basicsalaryErrors = this.formdata.amount ? [] : ['Basic Salary is required']
      this.allowanceErrors = this.formdata.amount ? [] : ['Allowances is required']
      this.loanAmountErrors = this.formdata.amount ? [] : ['Loan ammount is required']
      this.grossSalaryErrors  = this.formdata.amount ? [] : ['Gross Salary is required']
      this.loanpurposeErrors  = this.formdata.amount ? [] : ['Loan purpose is required']  
      this.disbursementError =  this.formdata.amount ? [] : ['Disbursement Mode is required']
      this.repaymentperiodErrors  = this.formdata.amount ? [] : ['Repayment Period is required']
      this.montlyrepaymentErrors  = this.formdata.amount ? [] : ['Montly repayment is required']
     
     if (this.formReady) {
      this.showConfirmModal = true;
      } 
      console.log(this.product_id);

      if (this.newPeriod > this.maxPeriod) {
      // If somehow it's greater (although you already handle this), reset it to max
      this.newPeriod = this.maxPeriod;
    }
       const form = {
        
  user:this.userData.user_id,
  LoanapplicationNo: this.loan_no,
  loanType: this.code.code?this.code.code:this.code,
  appliedamount: this.formdata.appliedamount,
  RepaymentPeriod:this.newPeriod,
  basicPay:this.formdata.basicPay,
  allowance:this.formdata.allowance,
  grosspay:this.formdata.grossSalary,
  deductions:0,
  loanpurpose: this.purposecode,
  disbursement : this.formdata.disbursement.name,
        };

     		this.loading = true
				var self = this

				let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}

				axios.post(`${this.$apiUrl}EditloanApplication`, form, config) 
				.then(function (res) {
					self.loading = false					
					const resp = res.data;
					console.log(resp);
					if(resp == 'True'){              
			          self.showToast(`Loan Edited succefully.`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 5500,
			          })
                self.GRequest(resp);
      setTimeout( () =>  self.GRequest(resp), 2500);
      
			        } else {
			          self.processingError = true
			        }                 
				})
				.catch(function (error) {
				  console.log(error)
				})
    },
    GRequest(loan_no){
      console.log(this.loan_no)
      this.$router.push({name: 'loan-LoansMoreDetails', params: { LoanapplicationNo:this.loan_no}});

    },

    GetLoanDetails () {
      this.loadSelect = true
      const self = this
      const form = {
        LoanapplicationNo:this.loan_no,
  user:this.userData.user_id

      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}IndividualLoanDetails`, form, config)
      .then(function (res) {

          self.loadSelect = false
          self.loading = false
          res = res.data
          self.details = res;
          console.log(res)

          self.formdata.AmountGuarantee= res.amount_guaranteed;
          self.formdata.disbursement= res.payment_mode;
          self.formdata.appliedamount = res.applied_amount;
          self.formdata.grossSalary=res.gross_salary;
          self.formdata.basicPay=res.basic_pay;
          self.purposecode=res.loan_purpose;
          self.formdata.allowance=res.total_allowance;
          self.formdata.productID=res.loan_product
          self.code= res.loan_product;
          self.newPeriod= res.installments;
          console.log(res.loan_product)
          //self.product_id=res.loanType
          self.setChange(self.code);
        
          console.log(self.code)
      })
      .catch(function (error) {
          console.log(error)
      })
    },
    GetLoanProducts () {
      this.loadSelect = true
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetLoanProducts`, self.userData.user_id, config)
      .then(function (res) {

          self.loadSelect = false
          self.loading = false
          res = res.data
          self.loans = res
          console.log(res);
      })
      .catch(function (error) {
          console.log(error)
      })
    },
    GetLoanPurpose () {
      this.loadpurpose = true
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetLoanPurposes`, self.userData.user_id, config)
      .then(function (res) {

          self.loadpurpose = false
          self.loading = false
          res = res.data
          self.purpose = res.map(function(item) {
      return {
        id: item.code,
        name: item.description
      }

    })
    console.log(self.purpose);
          
      })
      .catch(function (error) {
          console.log(error)
      })
    },

     setnewendDate(value){
      
      this.RepaymentPeriod = this.$options.filters.DateDiff(this.date, value)
    },
    setChange() {
      let my_loan = this.loans.filter(
        (item) => item.code.toLowerCase() === this.code.toLowerCase()
      );
      let val = my_loan[0];
      this.newPeriod = val.installments;
      this.maxPeriod = val.installments; // Set max period when loan is selected
      this.newInterest = val.interest_rate;
      this.code = val.code;
    },
    setSelected(value) {
      this.newInterest = value.interest_rate;
      this.RepaymentPeriod = value.repayment_period;
      this.newPeriod = value.installments;
      this.maxPeriod = value.installments; // Update max period only when new loan product is selected
    },
    validateInstallments() {
      // Ensure user can't increase installments beyond max period
      if (this.newPeriod > this.maxPeriod) {
        this.newPeriod = this.maxPeriod; // Reset to max if user tries to increase
      }
      // Allow reduction without resetting to original
    },
    
    GetloanRepamentDetails(){
      if(this.code==this.formdata.productID){
        this.code=this.loans.filter(item => item.code.toLowerCase() === this.code.toLowerCase())[0];
      }

      
const form = {
  product:this.code,
  user_id: this.userData.user_id,
  amount: this.formdata.appliedamount,
  start_date: this.date,
  period : this.RepaymentPeriod,

};
this.loading = true
const self = this

let config = {
  headers: {
    Authorization: this.userData.user_id+' '+this.token
  }
}

axios.post(`${self.$apiUrl}GetLoanSchedule`, form, config)
.then(function (res) {          
    self.loading = false
    self.showtable = true
    self.totalInterest=res.data.totalInterest
    console.log(res.data.totalInterest)
    res = res.data.result          
    self.schedule = res.slice();
    self.formdata.montlyrepayment=res.payment_amount
    self.totalLoanrepayment=res.totalLoanRepayments
})
.catch(function (error) {
    console.log(error)
})   

},
getschedule(){
  this.GetloanRepamentDetails();
  this.showInfo= true;
  this.showIterest=true;
},
getDeatils(value){
  this.GetloanRepamentDetails()
  this.montlyrepayment=value.payment_amount
  console.log(this.montlyrepayment)
  //this.Totalinterest=(this.newInterest/12/100)*this.formdata.appliedamount/this.RepaymentPeriod;
  
},
     grossSalaryQ(){
        
        this.grossSalary = (this.formdata.basicPay - this.formdata.allowance)
        //console.log( this.grossSalary);
    },
 getgross(value){
  		const val = value.id
   return this.grossSalary 
  	}
  },
  created () { 
    this.GetLoanProducts();         
    this.GetLoanPurpose(); 
    this.GetLoanDetails();
    this.today  = this.$options.filters.dateToYMD(new Date());
    this.date = this.today 
  	this.formdata.phone_no  = this.userData.mobile_number
    this.formdata.user  = this.userData.user_id
    this.formdata.paybill_code  = this.accdetails.accname
    this.today  = this.$options.filters.dateToYMD(new Date());
    this.date = this.today 
    if(this.userData.is_registered_mobile_user !=  1) {
      var id = 'fosa'
      this.PaymentOptions = this.PaymentOptions.filter((e)=>e.id !== id )
    }
  }
}
</script>